import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Detail Legal")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailLegalitas = _resolveComponent("DetailLegalitas", true)!
  const _component_DetailTableLegalitas = _resolveComponent("DetailTableLegalitas")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-primary me-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/superadmin/legal/legalitas')))
          }, " Kembali ")
        ])
      ])
    ]),
    _createVNode(_component_DetailLegalitas),
    _createVNode(_component_DetailTableLegalitas)
  ], 2))
}